// extracted by mini-css-extract-plugin
module.exports = {"blog-list":"blog_blog-list__GwzSn"};